import { useCallback, useEffect, useState } from 'react'
import { withBasePath } from './basePath'
import { readLocation, type AppLocation } from './routeTable'

interface NavigateOptions {
  replace?: boolean
  state?: unknown
}

export function useBrowserRouter() {
  const [location, setLocation] = useState<AppLocation>(() => readLocation(window.location))

  const navigate = useCallback((to: string, options: NavigateOptions = {}) => {
    const method = options.replace ? 'replaceState' : 'pushState'
    window.history[method](options.state ?? null, '', withBasePath(to))
    setLocation(readLocation(window.location))
  }, [])

  useEffect(() => {
    const handlePopState = () => setLocation(readLocation(window.location))
    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  return { location, navigate }
}
